import { render, staticRenderFns } from "./ProfesorJornadaParcialComponent.vue?vue&type=template&id=e102f782"
import script from "./ProfesorJornadaParcialComponent.vue?vue&type=script&lang=js"
export * from "./ProfesorJornadaParcialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports